export namespace CarModuleTest {

	export class Configurator implements Persistance{
		testOn: boolean;

		constructor(persistance?: Persistance) {
			this.testOn = persistance ? persistance.testOn : false;
		}
		
	}

	export interface Persistance {
		testOn: boolean;
	}
}